import "./Synonyms.css";
export default function Syn2(props) {
  //console.log(props.definitions.synonyms);
  if (props.definitions.synonyms) {
    return (
      <ul className="synonyms">
        {props.definitions.synonyms.map(function (synonyms, index) {
          return <li key={index}>\{synonyms}\</li>;
        })}
      </ul>
    );
  } else {
    return null;
  }
}
